<template>
  <div class="card p-2" style="min-height: 200px">
    <div class="table-responsive">
      <table class="table table-bordered">
        <thead>
        <tr>
          <th class="text-center">Incentive Level Id</th>
          <th class="text-center">Incentive Type</th>
          <th class="text-center">Product</th>
          <th class="text-center">Percentage</th>
          <th class="text-center">Level Name</th>
          <th class="text-center">Equivalent Designation</th>
          <th class="text-center">Commission %</th>
          <th class="text-center">Qualify Team Level</th>
          <th class="text-center">Qualify Team Level Qty</th>
          <th class="text-center">SalesTarget Criteria</th>
          <th class="text-center">Status</th>
          <th class="text-center">Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, i) in tableItems" :key="i">
          <td class="text-center text-capitalize">{{ item.id }}</td>
          <td class="text-center text-capitalize">{{ item.incentive_type }}</td>
          <td class="text-center">{{ item.product_name }}</td>
          <td class="text-center">{{ item.percentage }}</td>
          <td class="text-center">{{ item.level_name }}</td>
          <td class="text-center">{{ item.equivalent_designation }}</td>
          <td class="text-center">{{ item.commission }}</td>
          <td class="text-center">{{ item.qualify_level_name }}</td>
          <td class="text-center">{{ item.qualify_team_level_qty }}</td>
          <td class="text-center">{{ item.sales_target }}</td>
          <td class="text-center">{{ item.status }}</td>
          <td class="text-center">
            <button class="btn btn-primary btn-sm"
                    @click="goToEdit(item)"
                    style="cursor: pointer"
            >
              <i class="fas fa-eye"></i>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
      <p v-if="tableItems.length < 0" class="text-center mt-5">No data</p>
    </div>
  </div>
</template>

<script setup>
import {useRoute, useRouter} from "vue-router";

const props  = defineProps({
  tableItems     : Object,
});
const route  = useRoute();
const router = useRouter();

const goToEdit = (item) => {
  let param = {
    companyId: route.params.companyId,
    moduleId: route.params.moduleId,
    menuId: route.params.menuId,
    pageId: route.params.pageId
  }

  let query = route.query;
  query.incentiveSetupId = item.id;

  router.push({
    name:  'incentive-setup-add',
    params: param,
    query: query
  })
}

</script>
